import { PropsWithChildren } from 'react';

/** @deprecated use Header component instead */
export const KanbanHeader = ({ children }: PropsWithChildren) => (
  <div className="bg-card fixed top-0 right-0 left-0 z-4 box-border w-full pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pl-[env(safe-area-inset-left)]">
    {children}
  </div>
);
